<template>
  <div class="main">
    <div class="main_tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="风险监控" name="first">
                <safe-code ref="Codes"></safe-code> 
            </el-tab-pane>
            <el-tab-pane label="奖惩记录" name="second">
                <record-awards ref="Awards"></record-awards>
            </el-tab-pane>
        </el-tabs>
    </div>
  </div>
</template>
<script>
import SafeCode from './components/SafeCode.vue'//安全码
import RecordAwards from './components/RecordAwards.vue'//奖惩记录
export default {
    components:{
        SafeCode,
        RecordAwards,
    },
    data(){
        return{
            activeName:'first'
        }
    },
    mounted(){
        this.$refs.Codes.searchButtonInfo(true);
    },
    methods:{
        //切换界面
        handleClick(tab){
            switch(tab.name){
                case 'second':
                    this.$refs.Awards.searchButtonInfo(true);
                    break;
                default:
                    this.$refs.Codes.searchButtonInfo(true);
            }
        },
    }
}
</script>
<style scoped lang="scss">
@import'@/style/layout-main.scss';
/deep/ .el-tabs__content{
    position: static;
}

/deep/.main {
  background: none;
}
</style>